<template>
    <div>
        <UiEmailSubscription id="SbEmailSubscription" :blok="props.blok" :apr="false" @submit="subscribeEmail" />
    </div>
</template>

<script setup lang="ts">
import { useEmailSubscriptionStore } from '@nuxt-monorepo/base/app/store/emailSubscription';
import type { IEmailSubscriptionConfig } from '@nuxt-monorepo/ui/types';

const { t } = useI18n();
const props = defineProps<{ blok: IEmailSubscriptionConfig }>();
const emailSubscriptionStore = useEmailSubscriptionStore();
const backendError = ref('');
const config = useRuntimeConfig();

provide('backendError', backendError);

const subscribeEmail = async ({ email }) => {
    return (async () => {
        try {
            backendError.value = '';

            const resp = await fetch('/api/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email,
                    listId: config?.public.ITERABLE_LIST_ID,
                    signupSource: props.blok?.signupSource ?? '',
                }),
            });

            if (!resp.ok) {
                const err = await resp.json().catch(() => ({}));
                throw new Error(err?.message || `HTTP ${resp.status}`);
            }

            emailSubscriptionStore.updateIsSubscribed(true);
            return await resp.json().catch(() => null);
        } catch (err: any) {
            backendError.value = err?.message || t('forms.emailUnSubscriptionInvalid2');
            return null;
        }
    })();
};
</script>

<style lang="postcss" scoped>
#SbEmailSubscription {
    @apply w-full;
    :deep(.container) {
        .success,
        .error-tooltip {
            @apply hidden;
        }
    }
}
</style>
